import React, { Component } from 'react'

export class Leaderboard extends Component {
  render() {
    return (
      <div>Leaderboard</div>
    )
  }
}

export default Leaderboard